class RegimeTributarioController extends AbstractController
  @$inject = ['$injector', 'pathService', 'efRegimeTributarioService', 'regimeTributarioService']

  constructor: ($injector, pathService, @efRegimeTributarioService, @regimeTributarioService) ->
    super($injector)

    url = pathService.getViewUrl() + 'eficiencia-fiscal/view/configuracao/regime-tributario/'
    @modalRegime = @openPopup(url + 'modal.html', 'regimeTributarioModalController as ctrl', null, 'static')

    @loadingTracker = @promiseTracker()
    @loadData()

  loadData: ->
    @loadingTracker.addPromise(
      @efRegimeTributarioService.getList(
        (data) => @listOfRegimeTributario = data
      )
      @regimeTributarioService.getList(
        (data) =>
          @listOfRegimeTributarioRef = data
      )
    )

  adicionar: ->
    @modalRegime({
      regime: -> {}
      listOfRegimeTributarioRef: =>
        @listOfRegimeTributarioRef.select((item) =>
          !@listOfRegimeTributario.containsObject(item.id, 'regime_tributario_referencia.id')
        )
    }, (result) => @loadData())

  editar: (regime)->
    @modalRegime({
      regime: -> regime
      listOfRegimeTributarioRef: => @listOfRegimeTributarioRef
    }, (result) => @loadData())

  remover: (regime) ->
    @Confirm.warning("Atenção!",
      "Deseja realmente remover o regime tributário <strong>#{regime.regime_tributario_referencia.nome}</strong>? Essa ação não poderá ser desfeita.", {
        'Sim': =>
          @regimeTributarioService.delete(regime.id, =>
            Alert.success("Regime tributário <strong>#{regime.regime_tributario_referencia.nome}</strong> removido com sucesso.", "Sucesso!")
            @loadData()
          )
        'Não': null
      })


angular.module("eficienciaFiscalModule").controller('regimeTributarioController', RegimeTributarioController)

class RegimeTributarioModalController extends AbstractController
  @$inject = ['$injector', '$uibModalInstance', 'efRegimeTributarioService', 'regimeTributarioService', 'cstService', 'regime', 'listOfRegimeTributarioRef'];

  constructor: ($injector, @modalInstance, @efRegimeTributarioService, regimeTributarioService, cstService, @regime, @listOfRegimeTributarioRef) ->
    super($injector)

    @submitTracker = @promiseTracker()

    @listOfPis = @lazyLoad('eficiencia-fiscal->configuracao->listOfPis', (loaded) =>
      cstService.getListByType('pis', (data) =>
        loaded data
      )
    )

    @listOfCofins = @lazyLoad('eficiencia-fiscal->configuracao->listOfCofins', (loaded) =>
      cstService.getListByType('cofins', (data) =>
        loaded data
      )
    )

  salvar: (form, data) ->
    if form.$valid
      @submitTracker.addPromise(
        @efRegimeTributarioService.save(angular.copy(data),
          (data) =>
            if data.success
              @Alert.success('Configuração de regime tributário adicionado.', 'Sucesso')
              @modalInstance.close()

            @Alert.warning('O regime enviado já esta cadastrado!', 'Operação não realizada', 15000) unless data.success
        )
      ) unless data.id
      @submitTracker.addPromise(
        @efRegimeTributarioService.update(angular.copy(data),
          (data) =>
            @Alert.success('Configuração de regime tributário atualizado.', 'Sucesso')
            @modalInstance.close()
        )
      ) if data.id

angular.module("eficienciaFiscalModule").controller('regimeTributarioModalController', RegimeTributarioModalController)